module.exports = __webpack_public_path__ + "static/media/registration.a64c922a.svg";